import { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { PROPERTY, IMAGES } from '../../mock';
import LoginModal from '../LoginModal';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Link } from 'react-router-dom';

export default function Property() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [bridgeOpen, setBridgeOpen] = useState(false);

  const handleClick = (title) => (e) => {
    e.preventDefault();
    if (title === 'Vector Settle') setLoginOpen(true);
    else if (title === 'Vector Bridge') setBridgeOpen(true);
  };

  return (
    <section id="property" className="py-20 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 reveal">
            <div className="relative aspect-[4/5] w-full rounded-[24px] overflow-hidden shadow-[0_30px_80px_-30px_rgba(11,59,46,0.35)]">
              <img src={IMAGES.property} alt="Mediterranean villa" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B3B2E]/40 to-transparent" />
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#0B3B2E]/70 font-medium reveal">{PROPERTY.eyebrow}</p>
            <h2 className="mt-4 font-serif text-[40px] lg:text-[56px] leading-[1.05] text-[#0B3B2E] reveal">{PROPERTY.title}</h2>
            <p className="mt-6 text-[17px] leading-relaxed text-[#0E1F1A]/70 max-w-[620px] reveal">{PROPERTY.body}</p>

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {PROPERTY.products.map((p) => (
                <a key={p.title} href="#" onClick={handleClick(p.title)}
                  className="group reveal p-6 rounded-2xl bg-[#F5F1E8] border border-[#0B3B2E]/12 hover:border-[#0B3B2E] hover:-translate-y-1 transition-all duration-300 cursor-pointer">
                  <span className="inline-block text-[10px] uppercase tracking-[0.2em] text-[#C8944B] font-semibold">{p.tag}</span>
                  <h3 className="mt-2 font-serif text-[24px] text-[#0B3B2E]">{p.title}</h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-[#0E1F1A]/65">{p.description}</p>
                  <span className="mt-5 inline-flex items-center gap-1 text-[13px] font-medium text-[#0B3B2E]">
                    {p.link}
                    <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <LoginModal open={loginOpen} onOpenChange={setLoginOpen} defaultTab="login" />

      <Dialog open={bridgeOpen} onOpenChange={setBridgeOpen}>
        <DialogContent className="max-w-[440px] bg-[#F5F1E8] p-0 overflow-hidden">
          <div className="p-7">
            <DialogTitle asChild>
              <h2 className="font-serif text-[26px] text-[#0B3B2E]">Vector Bridge</h2>
            </DialogTitle>
            <DialogDescription className="text-[13px] text-[#0E1F1A]/60 mt-1">
              Log in as a referral partner, or apply to become one.
            </DialogDescription>
            <div className="mt-5 grid grid-cols-1 gap-2">
              <Link to="/partner/login" onClick={() => setBridgeOpen(false)}
                className="flex items-center justify-between px-5 h-12 rounded-full bg-[#0B3B2E] text-[#F5F1E8] hover:bg-[#12503F] font-medium text-[14px] transition-colors">
                Partner login <ArrowUpRight className="w-4 h-4" />
              </Link>
              <Link to="/partner/signup" onClick={() => setBridgeOpen(false)}
                className="flex items-center justify-between px-5 h-12 rounded-full border border-[#0B3B2E]/25 text-[#0B3B2E] hover:bg-[#0B3B2E]/5 font-medium text-[14px] transition-colors">
                Become a referral partner <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
}
